var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"wsc_loader--inline"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('span',{staticClass:"loader-label"},[_vm._v(_vm._s(_vm.$t('general.loading')))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f0efe1e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/loading.vue
// module id = 203
// module chunks = 39